module.exports = __webpack_public_path__ + "static/img/zeta_template_09.47165b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zeta_template_09.png
// module id = gNnT
// module chunks = 1